<script>
import WDatabasePerfTable from '@/views/performance/group/perfinfo/components/DatabasePerfTable';
import MapAPI from '@/api/topologymap/common';

import { columnDefault } from '@/constants/table';

export default {
  name: 'WTopologymapDatabasePerfTable',
  extends: WDatabasePerfTable,
  props: {
    active: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      columnDefault,
      tableTotal: 0,
      showSearchTool: false,
    };
  },
  methods: {
    loadStore() {
      if (this.active) {
        const tableParams = this.$refs.databaseTable.getParameter();
        const params = {
          managetypeId: 'DBMS',
          objDefineId: this.selectedObjDefineIds[0],
          objtypeId: this.selectedNode.objtypeId,
          ...tableParams,
          mapId: this.$store.getters.getCurrentMapId,
        };
        MapAPI
          .getPerformanceDatabaseGroupList(params)
          .then((result) => {
            if (result.data.success === true) {
              this.tableDatas = result.data.data;
              this.tableTotal = result.data.total;
            }
          });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/topologymap/components/perfoper/performance/components/TopologymapDatabasePerfTable.vue